export enum BannerComponentId {
  CreateTeamAfterFirstFailure = "CREATE_TEAM_AFTER_FIRST_FAILURE",
  MoveTeamAfterFirstFailure = "MOVE_TEAM_AFTER_FIRST_FAILURE",
  DeleteTeamFailure = "DELETE_TEAM_FAILURE",
  ChangesAfterFirstFailure = "CHANGES_AFTER_FIRST_FAILURE",
}
